import { serviceFeeType } from "./serviceFeeType";

const setServiceFee = (data) => ({ type: serviceFeeType.SET_SERVICE_FEE, payload: data });

export { setServiceFee };